export default "{\n    \"label\": \"Activo\"\n}\n"